export const debounce = <T extends Function>(fn:T, delay) => {
  let timer = -1;
  return (...args)=> {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(null, args);
    }, delay) as unknown as number;
  };
}